import React from "react";
import { Modal, Button, Image, Divider } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../app/common/modals/modalReducer";
import TimeAppForm from "../manager/ManagerTimeList/TimeAppForm";

export default function TimeAppModal(props) {
    const dispatch = useDispatch();
    let timeCurrent = props.timeData;
    let profileClient = props.profileClient;

    let header_cls = "orange_header";

    if (timeCurrent.status === "Approved") {
        header_cls = "green_header";
    } else if (timeCurrent.status === "Denied") {
        header_cls = "red_header";
    }

    return (
        <Modal size="large" open={true} onClose={() => dispatch(closeModal())} closeOnDimmerClick={false} trigger={<Button>Show Modal</Button>} closeIcon>
            <Modal.Header>
                <Image style={{ zIndex: 2, maxHeight: "130px", maxWidth: "130px", width: "auto" }} avatar spaced="right" size="small" src={profileClient.photoURL || "/assets/user.png"} />

                <div className={header_cls}>
                    <div className="ui right aligned header" style={{ marginRight: 40, marginTop: 5, color: "white" }}>
                        <h3>{timeCurrent.status}</h3>
                    </div>
                </div>
            </Modal.Header>

            <Modal.Content>
                <Modal.Description>
                    <div className="content_top">
                        <img className="img_header" src="/assets/your_documents.png" alt="Your Documents" />

                        <h2 className="ui center aligned header">APPROVE/DENY TIMETRACKING FORM</h2>
                    </div>

                    {timeCurrent.changeReason && timeCurrent.changeReason.length > 0 && (
                        <div>
                            <Divider />

                            <h3>CHANGE REQUEST:</h3>
                            {timeCurrent.changeReason}
                        </div>
                    )}

                    <Divider />

                    <TimeAppForm time={timeCurrent} />
                </Modal.Description>
            </Modal.Content>
        </Modal>
    );
}
